import {Component, inject, OnInit} from '@angular/core';

import {Router} from "@angular/router";
import {KeycloakService} from "keycloak-angular";
import {AuthPathEnum} from "../../@application/enums/auth-path.enum";
import {AlertService} from "../../../../../vendors/src/lib/services/alert.service";

@Component({
    selector: 'lib-sign-in',
    imports: [],
    templateUrl: './sign-in.component.html',
    styleUrl: './sign-in.component.css'
})
export class SignInComponent implements OnInit{

  private keycloakService = inject(KeycloakService);
  private router = inject(Router);
  private alertService = inject(AlertService);
  statusMessage = 'Redirecting to secure login...';
  hasError = false;

  ngOnInit(): void {
    this.startLoginFlow();
  }

  async startLoginFlow(): Promise<void> {
    this.hasError = false;
    this.statusMessage = 'Redirecting to secure login...';
    try {
      const isAuthenticated = await this.keycloakService.isLoggedIn();
      if (isAuthenticated) {
        this.alertService.showSuccess('Already authenticated! Redirecting to dashboard...');
        await this.router.navigate([AuthPathEnum.Initializing]);
        return;
      }


      await this.keycloakService.login({
        redirectUri: `${window.location.origin}/${AuthPathEnum.Initializing}`,
      });
    } catch (error) {
      console.error('Keycloak login failed', error);
      this.hasError = true;
      this.statusMessage = 'Unable to reach the identity provider. Please try again.';
      this.alertService.showError('Authentication failed. Unable to reach the identity provider. Please try again.');
    }
  }

  retry(): void {
    this.alertService.showInfo('Retry', 'Retrying authentication...');
    this.startLoginFlow().then();
  }
}
